import styled from "styled-components";

export const CreatePlanPageBackground = styled.div`
    background: #224053;
    width: 100%;
    height: auto;
    min-height: 100vh;
    font-family: Outfit;
`

export const CPPHeader = styled.div`
    height: 64px;
    width: 100%;
    display: flex;
    padding: 0 28px;
    align-items: center;
`

export const CPPHeaderProgress = styled.div`
    background: #3E6379;
    height: 6.7px;
    width: 100%;
    flex-shrink: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
`

export const CPPHeaderProgressFilled = styled.div`
    position: absolute;
    background: #44FF33;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => `${props?.progress}%`};
    transition: all 0.4s ease-in-out;
`

export const CPPInternalBackButton = styled.div`
    position: absolute;
    left: 10px;
    top: 10px;
`

export const CPPInternalContainer = styled.div`
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    min-height: calc(100% - 64px);
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    position: relative;
    @media (min-width: 768px) {
        padding: 45px 30px;
    }
`

export const CPPInternalTitle = styled.div`
    color: #FFF;
    text-align: center;
    font-size: ${props => props?.main ? '22px' : '18px'};
    font-weight: ${props => props?.main ? '600' : '400'};
    margin-bottom: ${props => props?.main ? 0 : '10px'};
    @media (min-width: 768px) {
        font-size: ${props => props?.main ? '24px' : '20px'};
        margin-bottom: ${props => props?.main ? 0 : '20px'};
    }
`

export const CPPNumberOfDaysContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    padding: 25px 0;
    @media (min-width: 768px){
        padding: 50px 0;
    }
`

export const CPPNumberOfDaysItem = styled.div`
    padding: 30px 10px;
    border-radius: 30px;
    background: #082046;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 400;
    cursor: pointer;
    font-size: 16px;
    color: ${props => props?.selected ? '#20fff8' : '#fff'};
    border: ${props => props?.selected ? '1px solid #20fff8' : '1px solid #082046'};
    transition: all 0.2s ease-in-out;
    position: relative;
    bottom: ${props => props?.selected ? '10px' : '0'};
`

export const CPPProceedButton = styled.button`
    background: #6e7fff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin: 20px auto;
    padding: 10px 25px;
    transition: all 0.1s ease;
    font-size: 16px;
    font-weight: 500;
    border-radius: 30px;
    @media(min-width: 768px) {
        font-size: 18px;
    }
    &:disabled {

    }
    &:hover {
        background: #5468ff;
    }
`

export const CPPSessionLengthContainer = styled.div`
    background: #071f45;
    padding: 40px;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 20px;
    width: 100%;
    @media (min-width: 768px) {
        width: 60%;
        margin-top: 30px;
        padding: 50px;
    }
`

export const CPPSessionLengthContainerTitle = styled.div`
    color: #20fff8;
    font-size: 16px;
    margin-bottom: 20px;
`

export const CPPTimeButton = styled.div`
    background: #537ab7;
    font-size: 13px;
    color: ${props => props?.selected ? '#20fff8' : '#FFF'};
    width: 200px;
    height: 75px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: ${props => props?.left ? '20px 0 0 20px' : '0 20px 20px 0'};
    @media (min-width: 768px) {
        font-size: 16px;
    }
`

export const CPPTimeSelectorContainer = styled.div`
    width: 150px;
    margin: 20px auto;
    color: #FFF;

    .MuiList-root{
        scrollbar-width: thin;
        scrollbar-color: #00000080 #ddd;
    
        /* Width of the scrollbar */
        ::-webkit-scrollbar {
            width: 5px;
        }
        
        /* Background color of the scrollbar thumb */
        ::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.4);
            border-radius: 5px;
        }
        
        /* Background color of the scrollbar track */
        ::-webkit-scrollbar-track {
            background: #ddd;
            border: 1px solid #ccc;
        }
        
        /* Hide the scrollbar buttons */
        ::-webkit-scrollbar-button {
            display: none;
        }
    }

`